export default {
  defaultKpiName: 'Vendas',
  linkCopied: 'Link copiado para a área de transferência!',
  kpi: 'KPI',
  sharePlan: 'Compartilhar Plano',
  share: 'Compartilhar',
  sharingDisabled: 'Compartilhamento desativado',
  sharingEnabled: 'Compartilhamento ativado',
  creatingLink: 'Criando Link...',
  done: 'Pronto',
  budget: 'Orçamento',
  upTo: 'até {value}',
  restrictions: 'Restrições',
  spendIn: 'Gasto em',
  and: 'e',
  predictedSales: '{kpi} projetadas',
  fullPeriodSummary: 'Resumo do Período Completo',
  monthlyDetailView: 'Visão Detalhada Mensal',
  weeklyDetailView: 'Visão Detalhada Semanal',
  touchpoints: 'Pontos de Contato',
  segments: 'Segmentos',
  admin: 'Admin',
  mediaSpendCalendar: 'Calendário de Gasto em Mídia',
  rawOutput: 'Saída RAW',
  injectChanges: 'Injetar alterações',
  loading: 'Carregando...',
  unrestricted: 'Sem Restrições',
  moreThan: 'Mais de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exatamente',
  betaOptimizerTooltip: 'Este plano usa o novo otimizador (beta)',
  // XLSX download
  xlsxPlan: 'Plano',
  xlsxFirstValue: 'Primeiro valor',
  xlsxSecondValue: 'Segundo valor',
  xlsxShareOfBudget: 'Percentual do orçamento',
  xlsxTouchpoint: 'Touchpoint',
  xlsxVariability: 'Variabilidade',
  xlsxTotal: 'Total',
  spendByTouchpoint: 'Investimento por Touchpoint',
  spendBySegment: 'Investimento por Segmento',
  mediaKpiBySegment: '{kpi} de Mídia por Segmento',
  microaudienceContribution: 'Contribuição ao KPI por Microaudiência'
}
